export enum QueryKeyName {
  LoadUser = 'LoadUser',
  GetLocationsStats = 'GetLocationsStats',
  GetPlant = 'GetPlant',
  GetTopic = 'GetTopic',
  GetSection = 'GetSection',
  GetSections = 'GetSections',
  GetActionItems = 'GetActionItems',
  GetQuestions = 'GetQuestions',
  GetPlantQuestions = 'GetPlantQuestions',
  GetAttachmentFiles = 'GetAttachmentFiles',
  GetComments = 'GetComments',
  GetActionComments = 'GetActionComments',
  GetPomUsers = 'GetPomUsers',
  GetUser = 'GetUser',
  GetRefLinks = 'GetRefLinks',
  GetDocsLink = 'GetDocsLink',
  GetYearlyDataPoints = 'GetYearlyDataPoints',
  GetMonthlyDataPoints = 'GetMonthlyDataPoints'
}
